module.exports = __webpack_public_path__ + "static/img/no70img.3152e81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/no70img.png
// module id = ypqM
// module chunks = 1